import Auth from "../auth/Auth";
import Notification from "../notification/Notification";

const Http = async (status, message, props) => {
  switch (status) {
    case 200:
      Notification.success(message);
      break;
    case 201:
      Notification.success(message);
      break;
    case 400:
      Notification.danger(message);
      break;
    case 401:
      Auth.onLogout(props.setUser, false);
      break;
    case 403:
      console.log("403");
      break;
    case 404:
      console.log("404");
      break;
    case 422:
      Notification.danger(message);
      break;
    default:
      console.log("error not found");
      break;
  }
};

export default Http;
